import axios from "axios";

export class AddressNotFound extends Error {
  constructor(message) {
    super(message);
    this.name = "AddressNotFound";
  }
}

export async function searchMapPosition(street, city, country, postal_code) {
  if (street === undefined || city === undefined || country === undefined || postal_code === undefined)
    throw new Error("Missing Parameter on searchMapPosition");
  // Build Geo Search URL
  street = encodeURIComponent(street);
  city = encodeURIComponent(city);
  country = encodeURIComponent(country);
  postal_code = encodeURIComponent(postal_code);
  const url = `https://nominatim.openstreetmap.org/search?format=json&street=${street}&city=${city}&country=${country}&postal_code=${postal_code}`;
  const response = await axios.get(url);
  console.log(response.data);
  if (response.data.length === 0) {
    throw new AddressNotFound("No address found", "Please check your informations and try again.");
  }
  const lat = response.data[0]['lat'];
  const lon = response.data[0]['lon'];
  return { lat, lon };
}
